import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ErrorHandlerService } from '@cashbox-app/service/error-handler.service';
import { AppEventModel, AppEventType, HxEventService, HxFioPipe } from 'hx-services';
import { DatePipe, NgFor, NgIf } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';

/**
 * Component of invoice event list
 *
 * @example  <app-invoice-events [id]="someId"></app-invoice-events>
 */
@Component({
  selector: 'app-invoice-events',
  templateUrl: './invoice-events.component.html',
  imports: [NgIf, NgFor, DatePipe, TranslocoPipe, HxFioPipe]
})
export class InvoiceEventsComponent implements OnChanges {
  @Input() id?: number;
  events: AppEventModel[] = [];
  eventList = new Map<AppEventType, string>([
    [AppEventType.ORDER_CREATED, 'info'],
    [AppEventType.ORDER_MODIFIED, 'brand'],
    [AppEventType.ORDER_PACKED, 'warning'],
    [AppEventType.ORDER_DECORED, 'focus'],
    [AppEventType.ORDER_SHIPPED, 'warning'],
    [AppEventType.ORDER_RECEIVED, 'success'],
    [AppEventType.ORDER_CANCELLED, 'danger'],
    [AppEventType.ORDER_PAID, 'success'],
    [AppEventType.ORDER_TAKEN, 'warning'],
    [AppEventType.ORDER_RETURNED, 'metal'],
    [AppEventType.ORDER_REFUNDED, 'danger',],
    [AppEventType.PRODUCT_REFUNDED, 'metal',],
    [AppEventType.ORDER_UNARCHIVED, 'light'],
    [AppEventType.INVOICE_DISCARDED, 'danger'],
    [AppEventType.INVOICE_NEW, 'info'],
    [AppEventType.INVOICE_ACCEPTED, 'success'],
    [AppEventType.INVOICE_REJECTED, 'danger'],
    [AppEventType.INVOICE_SENT, 'warning'],
    [AppEventType.INVOICE_CANCELLED, 'danger'],
    [AppEventType.INVOICE_RESTORATION, 'brand'],
    [AppEventType.INVOICE_RESTORED, 'brand'],
  ]);

  constructor(
    private eventService: HxEventService,
    private errorService: ErrorHandlerService,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.id) {
      this.loadEvents(this.id);
    }
  }

  private async loadEvents(id: number) {
    try {
      this.events = await this.eventService.getInvoiceEventList(id);
    } catch (err: any) {
      this.errorService.handle(err);
    }
  }

}
